<template>
	<div class="lefan-index">
		<HNB></HNB>
		<!-- <Banner></Banner> -->
		<!-- <div class="banner animated fadeIn" :style="item.classname" v-for="(item,index) in posters" @click="know_more(item.activename)" v-show="index==bannernum"> -->
		<!-- <div class="banner animated fadeIn" v-for="(item,index) in posters" @click="know_more(item.product_id[0].active_name)" v-show="index==bannernum"> -->
		<!-- <div class="banner-container">
			<div class="banner animated fadeIn" v-for="(item,index) in posters" @click="know_more(index)"
				v-show="index==bannernum">
				<div class="banner-box" v-if="!item.isBanner">
					<div class="banner-title">
						<div  class="banner-title-box animated fadeInUp" :style="bannerTitleBoxBg">
							<span class="banner-title-content-h1">{{item.product_id[0].product_name}}</span>
							<span class="banner-title-content-h2">{{item.product_id[0].desc}}</span>
							<span class="banner-title-content-link">{{know}}</span>
						</div>
					</div>
					<div class="banner-image animated fadeInUp">
						<img v-if="!item.isBanner" :src="item.product_id[0].product_honor_img" class="swiper-honor-img" />
						<div class="banner-image-box">
							<img :src="item.swiper_img" />
						</div>
					</div>
				</div>
				<div v-else class="banner-box">
					<img :src="item.swiper_img" />
				</div>
			</div>
		</div> -->
		<div class="banner-container">
			<div class="banner animated fadeIn" v-for="(item,index) in posters" @click="know_more(index)"
				v-show="index==bannernum">
				<div class="banner-box" v-if="item.is_banner==1">
					<div class="banner-title">
						<div class="banner-title-box animated fadeInUp" :style="bannerTitleBoxBg">
							<span class="banner-title-content-h1">{{item.lf_func_lefan_product[0].product_name}}</span>
							<span class="banner-title-content-h2">{{item.lf_func_lefan_product[0].desc}}</span>
							<span class="banner-title-content-link">{{know}}</span>
						</div>
					</div>
					<div class="banner-image animated fadeInUp">
						<img v-if="!item.is_banner" :src="lf_func_lefan_product[0].product_honor_img"
							class="swiper-honor-img" />
						<div class="banner-image-box">
							<img :src="item.swiper_img" />
						</div>
					</div>
				</div>
				<div v-else class="banner-box">
					<img :src="item.swiper_img" />
				</div>
			</div>
		</div>


		<div class="page-box">
			<div class="line-box positionUp">
				<div v-for="item in cardList" :key="item.title" class="item-box" :class="item.class"
					@click="toherf(item.acitve)">
					<span class="card-title">{{item.title}}</span><br />
					<span class="card-content">{{item.content}}</span><br />
					<SvgIcon class="svgicon" style="position: relative;z-index: 99;padding-left: 8%; padding-top: 6%;"
						:svg-name="item.svg" size=40></SvgIcon>
					<img v-if="item.imgUrl" :src="item.imgUrl" class="bg-img" />
					<!-- <SvgIcon :svg-name="item.IFsvg" style="position: absolute;top: 50%;right: 4%;z-index: 99;" size=60></SvgIcon> -->
					<div class="shadow"></div>
				</div>
			</div>
		</div>


		<div class="page-box">
			<div class="line-box positionDown">
				<div class="half-div" @click="hRpush()" style="pointer-events: auto;">
					<p class="part-title">部位推荐</p>
					<ul class="parts">
						<li v-for="item in parts" :key="item.title">
							<SvgIcon :svg-name="item.svgName" :size="item.svgSize"></SvgIcon>
							<span>{{item.title}}</span>
						</li>
					</ul>
				</div>
				<div class="half-div " style="position: relative;">
					<div class="shadow"
						style="width: 100%;height: 170px; position: absolute;right: 0%; top: 0%;background: rgba(0, 0, 0, 1);opacity: 0.5; z-index: 99;">
					</div>

					<div v-for="(item,i) in news" v-if="i==num" @click="openNews(item)">
						<div class="half-div-title">
							<p class="">
								{{item.news_title}}
							</p>
						</div>
						<div class="news animated fadeIn ">
							<img class="newsBgimg" :src="item.news_home_img"
								style="width: 100%; height: 100%;pointer-events:auto;transition:all 1s ease-out;">
						</div>
					</div>
					<SvgIcon class="half-div-svg1" svg-name="signRightWhite" size=50 style="padding-left: 1.875rem;">
					</SvgIcon>
				</div>
			</div>
		</div>
		<p class="geo-last-updated">本文最后更新于：{{ '' | yearMonth }}</p>
		<BS :BsTitle="bsTitle"></BS>
		<PopUp v-if="popUp" @clickBac="clickBac" :productHtml="popHtml" :sampleName="sampleName"></PopUp>
	</div>

</template>

<script>
	import HNB from '../components/HeaderNavigationBar.vue'
	import Banner from '../components/Banner.vue'
	import BS from '../components/bottomShow.vue'
	import SvgIcon from '../components/SvgIcon.vue'
	import PopUp from '../components/LFPopUp.vue'
	import axios from 'axios'
	import request from '../common/request.js'

	export default {
		name: 'index',
		data() {
			return {
				sampleName: '',
				// bannerstyle: ' !important',
				popUp: false,
				num: '0',
				news: [],
				bannernum: '',
				// 轮播图
				posters: [],
				bannerTitleBoxBg: 'background-image: url(' + this.GLOBAL.imgHost + '/images/lf-bg.png);',
				know: '进一步了解',
				bsTitle: ['首页'],
				cardList: [{
						title: '关于乐范',
						content: '厦门乐范健康科技...',
						class: 'green-bg',
						imgUrl: this.GLOBAL.imgHost + '/images/index/1.png',
						svg: 'signRightWhite',
						acitve: 'aboutus',
						IFsvg: ''
					},
					{
						title: '销量领先产品',
						content: '全网人气销量排行榜',
						class: 'gray-bg',
						imgUrl: this.GLOBAL.imgHost + '/images/index/22.jpg',
						svg: 'signRightWhite',
						acitve: 'sales',
						IFsvg: ''
					},
					{
						title: '跨界联名产品',
						content: '熊本熊 | 迪士尼 | 得到 | 吴晓波频道 | 日行千里……',
						class: 'three-bg',
						imgUrl: this.GLOBAL.imgHost + '/images/index/4.png',
						svg: 'signRight',
						acitve: 'jointproduct',
						IFsvg: ''
					}
				],
				parts: [{
						title: '全身',
						svgName: 'body',
						svgSize: 40,
					},
					{
						title: '头部',
						svgName: 'head',
						svgSize: 40,
					},
					{
						title: '颈部',
						svgName: 'shouder',
						svgSize: 40,
					},
					{
						title: '腰部',
						svgName: 'waist',
						svgSize: 40,
					},
					{
						title: '腿部',
						svgName: 'leg',
						svgSize: 40,
					},
					{
						title: '脚部',
						svgName: 'foot',
						svgSize: 40,
					}
				],
				homedata: [],
				popHtml: ''

			};
		},
		components: {
			HNB,
			Banner,
			BS,
			SvgIcon,
			PopUp
		},
		async mounted() {
			this.play()
			// this.listData()
			// 获取轮播图列表
			// request.uniRequest('/swiper/getSwiperList').then(res => {
			// 	// console.log('swiper---------', res);
			// 	this.posters = res.data.filter(item => item.web_type == 0)
			// 	// console.log('-------------poster',this.posters);
			// }).catch(e => {})
			// 获取轮播图列表
			await this.getSwiperList()
			// 获取新闻列表
			await this.getNewsList()
			// request.uniRequest('/news/getNewsList')
			// 	.then(res => {
			// 		// console.log('成功了吗news', res)
			// 		// this.posters = res.data.filter(item => item.web_type == 0)
			// 		this.news = res.data
			// 		// console.log('新闻--------', this.news);
			// 	}).catch(e => {})
			
			
		},
		methods: {
			async getSwiperList() {
				// let res = await this.$Cloud.table(`lf_func_lefan_swiper`).where({link_table_array:['swiper']}).get({ page: 0, pageSize: 1000 })
				let res = await this.$Cloud
					.table(`lf_func_lefan_swiper`)
					.where({
						link_table_array: ['swiper']
					})
					.get({
						page: 0,
						pageSize: 1000
					})
			
				const {
					code,
					data
				} = res
			
				if (code == 200) {
					this.posters = data.filter(item => {
						return item.web_type == 1 && item.is_check == 2
					})
					console.log('获取轮播图123', this.posters)
				}
			
			
			},
			async getNewsList() {
				let res = await this.$Cloud.table(`lf_func_lefan_news`).get({ 
					page: 0, 
					pageSize: 100,
					sort_by: 'upload_time',
					order_by: 'desc'
				})
				
				console.log('获取新闻列表',res)
				
				const {code,data} = res
				if(code == 200) {
					this.news = data.filter(item=>item.is_check==2)
				}
			},
			openNews(item) {
				let routeUrl
				let startTime
				let endTime
				let timestamp
				timestamp = new Date().getTime()
				if(item.effect_time) {
					startTime = new Date(item.effect_time[0]).getTime()
					endTime = new Date(item.effect_time[1]).getTime()
				}
				if (startTime && endTime && timestamp <= endTime && timestamp >= startTime) {
					routeUrl = item.openurl
					window.open(routeUrl, '_blank');
				} else {
					routeUrl = this.$router.resolve({
						path: "/news",
						query: {
							id: item.id
						}
					});
					window.open(routeUrl.href, '_blank');
				}

			},
			openhref() {
				let that = this
				if (that.num == 0) {
					window.open('https://tech.china.com/article/20200325/20200325486377.html', '_blank');
				}
				if (that.num == 1) {
					window.open('http://news.jxntv.cn/2020/0402/9366121.shtml', '_blank');
				}
				if (that.num == 2) {
					window.open('https://www.toutiao.com/a6794635368181268995/', '_blank');
				}
				if (that.num == 3) {
					window.open('https://www.sohu.com/a/333936067_100210898', '_blank');
				}
				if (that.num == 4) {
					window.open('https://zhuanlan.zhihu.com/p/42130491', '_blank');
				}
			},
			toherf(e) {
				if (e == 'aboutus') {
					let routeUrl = this.$router.resolve({
						path: "/about-us",
					});
					window.open(routeUrl.href, '_self');
				}
				if (e == 'jointproduct') {
					let routeUrl = this.$router.resolve({
						path: "/jointproduct",
					});
					window.open(routeUrl.href, '_self');
				}
				if (e == 'sales') {
					let routeUrl = this.$router.resolve({
						path: "/sales",
					});
					window.open(routeUrl.href, '_self');
				}

			},
			hRpush() {
				this.$router.push({
					path: '/hR'
				})
			},
			autoplay() {
				this.bannernum++
				if (this.bannernum == this.posters.length) {
					this.bannernum = 0
				}

			},
			autoplay1() {
				this.num++
				if (this.num == this.news.length) {
					this.num = 0
				}
			},
			play() {
				setInterval(this.autoplay, 6000)
				setInterval(this.autoplay1, 8000)
			},
			open(url) {
				let Url = url
				// console.log("url", Url)
				window.open(Url, '_blank')
			},
			know_more(e) {


				if (e == 'wuxiaobo') {
					window.open('https://leravan.tmall.com/?spm=a1z10.3-b-s.w5001-21792119858.2.2f825759flC96i', '_blank');
				} else {
					// let routeUrl = this.$router.resolve({
					// path: "/Productstation",
					// query: {
					// 	globalname: e
					// 	}
					// });
					// window.open(routeUrl.href, '_blank');

					this.popHtml = this.posters[e].lf_func_lefan_product[0].product_html

					// console.log('popUp', this.popUp, e);
					document.body.style.overflow = 'hidden';
					// this.sampleName = e;
					this.popUp = true;
					// console.log('popUp', this.popUp);
				}
			},
			clickBac() {
				this.popUp = false;
				document.body.style.overflow = 'auto';
			},
			listData() {
				let that = this;
				let project_name = "web";
				let type = 'CPPPXW';
				let data = {
					"project_name": project_name,
					"type": type,
				}
				// console.log("haha");
				let requests = request.getQueryData(data || {})
				// console.log("haha", requests);
				// axios.post('/api_app/v2/mall/configinfo', // 还可以直接把参数拼接在url后边
				// 	requests).then(function(data) {
				// 	console.log("data", data);
				// 	if (data.data.ResultCode == 200) {
				// 		for (let item of data.data.data) {
				// 			let poster = {
				// 				// {
				// 				// 		title: '乐范联合厦航，助力安心复工',
				// 				// 		info: '此次乐范与厦航的合作，不仅仅是赠送口罩这么简单，领取完口罩后，点击“随便逛逛”，里面还有乐范为大家准备的厦航专属福利......',
				// 				// 		time: ' 2020-04-02',
				// 				// 		url: 'http://news.jxntv.cn/2020/0402/9366121.shtml',
				// 				// 		newsBg: this.GLOBAL.imgHost + '/images/newsinfo/2.jpg'
				// 				// 	},
				// 				title: item.title,
				// 				info: item.info,
				// 				time: item.time,
				// 				url: item.url,
				// 				newsBg: item.newsImg.url
				// 			}
				// 			that.news.push(poster);

				// 		}

				// 	}
				// }).catch(function(err) {
				// 	console.log('err', err);
				// });
			}
		}
	}
</script>
<style>
	@import url("../common/animate.min.css");

	.half-div-info {
		width: 90%;
		text-align: left;
		color: white;
		font-size: 0.85rem;

		font-weight: 400;
		position: absolute;
		z-index: 99;
		top: 40%;
		left: 5%;
	}

	.half-div-svg1 {
		text-align: left;
		position: absolute;
		z-index: 99;
		top: 70%;
		left: -1% !important;
	}

	.banner-container {
		height: 625px;
		width: 100%;
		background-color: #FFFFFF;
	}

	.banner {
		width: 100%;
		height: 22.5rem;
		padding-top: 200px;
		padding-bottom: 5%;
		max-height: 42.625rem;
		background: rgba(250, 250, 250, 1);
		display: flex;
		flex-direction: row;
		justify-content: center;
		overflow: hidden;
		cursor: pointer;
		animation-duration: 1.5s;
	}

	.banner-box {
		width: 100%;
		max-width: 1024px;
		display: flex;
		flex-direction: row;
	}

	.banner-title {
		width: 50%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		position: relative;
		line-height: 50px;
	}

	.banner-title-content-h1 {
		width: 31.25rem;
		font-size: 2rem;
		font-family: Alibaba-PuHuiTi-M;
		font-weight: 650;
		color: rgba(24, 24, 24, 1);
		margin-bottom: 40px;
		text-indent: 1rem;
	}

	.banner-title-box {
		animation-duration: 1.5s;
		display: flex;
		flex-direction: column;
		text-align: left;
		background-size: 40px 40px;
		background-repeat: no-repeat;
		margin-left: 25px;
	}

	.banner-title .lf-icon {
		position: absolute;
		top: 0;
		left: 0;
	}

	.banner-image {
		width: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
		animation-duration: 1.5s;
		position: relative;
	}

	.banner-image-box {
		width: 60%;
		position: relative;
		/* margin-top: 10%; */
	}

	.banner-image-box img {
		width: 100%;
		display: block;
	}
</style>
<style scoped>
	body {
		background: rgba(241, 241, 241, 1);
	}

	.lefan-index .page-box {

		width: 100%;
		display: block;
		background-color: #FFFFFF;
	}

	.lefan-index .page-box:hover {
		cursor: pointer;
	}

	.lefan-index .line-box {
		width: 100%;
		height: 9.375rem;
		max-width: 1024px;
		margin: auto;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		box-shadow: 0px 25px 50px 0px rgba(41, 44, 51, 0.1);
		background-color: white;
	}

	.lefan-index .card-box {
		width: 100%;
		max-width: 1024px;
		box-shadow: 0px 25px 50px 0px rgba(41, 44, 51, 0.1);
	}

	.lefan-index .item-box {
		width: 100%;
		height: 100%;
		display: inline-block;
		text-align: left;
		pointer-events: none;
		/* padding: 1.875rem 11rem 0 1.875rem; */
		/* padding-right: 10.25rem; */
		position: relative;
		z-index: 1;
	}

	.lefan-index .item-box * {
		z-index: 20;
	}

	.lefan-index .item-box span {
		display: inline-block;
		margin-top: 0.625rem;
		color: rgba(24, 24, 24, 1);

	}

	.lefan-index .card-title {
		font-size: 18px;
		font-weight: 700;
		padding-left: 8%;
		padding-top: 3%;
		font-family: Alibaba-PuHuiTi-M;
	}

	.lefan-index .card-content {
		width: 40%;
		font-size: 0.7rem;
		font-weight: 400;
		padding-left: 8%;
	}

	.lefan-index .card-sign {
		margin-top: 1.25rem;
		font-size: 50px;
		opacity: 0.6;
	}

	.lefan-index .green-bg {
		background-color: #00C785;

	}

	.lefan-index .green-bg:hover {}

	.lefan-index .green-bg span {
		color: white;
	}


	.lefan-index .gray-bg {
		overflow: hidden;
	}

	.lefan-index .gray-bg .bg-img:hover {
		transform: scale(1.1);
	}

	.lefan-index .gray-bg .shadow {

		background: rgba(0, 0, 0, 1);
		opacity: 0.5;
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0%;
		left: 0%;
	}

	.lefan-index .gray-bg span {
		z-index: 99;
		position: relative;
		color: white;
		position: relative;
	}

	.lefan-index .three-bg {
		transform: scale(1.1);
		transition: 1s;

	}

	.lefan-index .three-bg .bg-img:hover {
		transform: scale(1.1);
		transition: 1s;
	}

	.lefan-index .three-bg .svgicon {
		padding-top: 0 !important;
	}

	.lefan-index .half-div {
		width: 50%;
		height: 170px;
		background-color: white;
		overflow: hidden;
		pointer-events: none;
	}

	.lefan-index .parts {
		max-width: 1024px;
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		list-style-type: none;
		padding: 0;
		margin-top: 1rem;
	}

	.lefan-index .part-title {
		text-align: left;
		font-family: Alibaba-PuHuiTi-M;
		font-size: 18px;
		font-weight: 700;
		padding-left: 1.875rem;
		cursor: pointer;
		margin-top: 1rem;
	}

	.lefan-index .parts li {
		text-align: center;
	}

	.lefan-index .news {
		width: 100%;
		background-color: #000000b8;
		color: white;
		display: flex;
		align-items: flex-start;
		flex-direction: column;
		justify-content: flex-start;
		animation-duration: 2.5s;
		/* background-image: url(/images/index/3.png); */
		background-repeat: no-repeat;
		background-position: center;
		background-origin: border-box;
		background-size: 100% 100%;
	}

	.lefan-index .news p {
		text-align: left;
		padding-left: 1.875rem;
		display: block;
		margin-bottom: 0;
		max-width: 370px;
		margin-top: 25px;

	}

	.lefan-index .positionUp {
		position: relative;
		top: -15px;
		z-index: 1;
	}

	.lefan-index .positionDown {
		position: relative;
		top: 15px;
		z-index: 1;
	}

	.bg-img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		pointer-events: auto;
		transition: all 1s ease-out;
	}

	.newsBgimg:hover {
		transform: scale(1.1);
		transition: 1s;
	}

	.lefan-index .swiper-honor-img {
		width: 80px;
		position: absolute;
		right: 0;
		top: 0;
	}
	.lefan-index .half-div-title {
		color: white;
		font-family: Alibaba-PuHuiTi-M;
		position: absolute;
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: flex-start;
		z-index: 99;
		top: 0;
		left: 0;
		width: 100%;
		padding: 20px;
		height: 40px;
		font-weight: 550;
		font-size: 18px;
		text-align: left;
		text-indent: 2px;
		box-sizing: border-box;
	}
</style>
